/* =====================================================================
   PART 1 — YOUR EXISTING FILE, UNCHANGED
   ===================================================================== */
(function () {
  var TOP_THRESHOLD = 80; // always show the nav within this many px of the top
  var MIN_DELTA = 5; // ignore sub-pixel/momentum scroll jitter

  var lastScrollY = Math.max(window.scrollY, 0);
  var ticking = false;

  function updateNavVisibility() {
    var currentScrollY = Math.max(window.scrollY, 0);
    var diff = currentScrollY - lastScrollY;

    if (currentScrollY <= TOP_THRESHOLD) {
      document.body.classList.remove('nav-hidden');
    } else if (diff > MIN_DELTA) {
      document.body.classList.add('nav-hidden');
    } else if (diff < -MIN_DELTA) {
      document.body.classList.remove('nav-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateNavVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );
})();


/* =====================================================================
   PART 2 — ADDED: press + drag finger slider logic.
   Uses only the classes/attributes that already exist in your Liquid
   file (.mobile-bottom-nav--item, .mobile-bottom-nav-item--icon,
   active-nav-item, [data-bottom-nav]). No class is renamed, no link
   is touched — this only reads the existing <a href> and calls
   .click() on it at the right moment.
   ===================================================================== */
(function () {
  function initMobileBottomNav(nav) {
    if (!nav || nav.dataset.bottomNavInitialized === 'true') {
      return;
    }

    nav.dataset.bottomNavInitialized = 'true';

    const items = Array.from(
      nav.querySelectorAll('.mobile-bottom-nav--item')
    );

    if (items.length < 2) {
      return;
    }

    const dragThreshold = 8;

    /* ---------- Sliding pill ---------- */

    const ICON_SELECTOR = '.mobile-bottom-nav-item--icon';

    const thumb = document.createElement('span');
    thumb.className = 'mobile-bottom-nav--thumb no-anim';
    thumb.setAttribute('aria-hidden', 'true');
    nav.insertBefore(thumb, nav.firstChild);

    let thumbX = 0;
    let thumbV = 0;
    let thumbTargetX = 0;
    let thumbY = 0;
    let thumbW = 44;
    let thumbH = 34;
    let rafId = 0;
    let lastTime = 0;

    function getIconRect(index) {
      const icon = items[index].querySelector(ICON_SELECTOR) || items[index];
      return icon.getBoundingClientRect();
    }

    function getItemCenterX(index) {
      const rect = getIconRect(index);
      return rect.left + rect.width / 2 - nav.getBoundingClientRect().left;
    }

    function measureThumb() {
      const navRect = nav.getBoundingClientRect();
      const rect = getIconRect(0);

      thumbW = thumb.offsetWidth || rect.width;
      thumbH = thumb.offsetHeight || rect.height;
      thumbY = rect.top + rect.height / 2 - navRect.top - thumbH / 2;
    }

    function renderThumb(x, scaleX, scaleY, rotate) {
      thumb.style.transform =
        'translate3d(' + (x - thumbW / 2) + 'px,' + thumbY + 'px,0) ' +
        'rotate(' + (rotate || 0) + 'deg) ' +
        'scale(' + (scaleX || 1) + ',' + (scaleY || 1) + ')';
    }

    function moveThumbTo(index, animate) {
      if (index < 0) {
        thumb.style.opacity = '0';
        return;
      }

      measureThumb();

      const wasHidden = thumb.style.opacity !== '1';
      const jump = wasHidden || animate === false;

      if (jump) {
        thumb.classList.add('no-anim');
      }

      thumb.style.opacity = '1';

      thumbX = getItemCenterX(index);
      thumbTargetX = thumbX;
      thumbV = 0;
      renderThumb(thumbX);

      if (jump) {
        void thumb.offsetWidth;
        thumb.classList.remove('no-anim');
      }
    }

    function tickThumb(now) {
      const dt = Math.min((now - (lastTime || now)) / 16.667, 3) || 1;
      lastTime = now;

      thumbV += (thumbTargetX - thumbX) * 0.16 * dt;
      thumbV *= Math.pow(0.72, dt);
      thumbX += thumbV * dt;

      const speed = Math.abs(thumbV);
      const stretch = Math.min(speed / 11, 0.4);
      const tilt = Math.max(-8, Math.min(8, thumbV * 0.5));

      renderThumb(thumbX, 1 + stretch, 1 - stretch * 0.3, tilt);

      if (Math.abs(thumbTargetX - thumbX) > 0.3 || speed > 0.3) {
        rafId = requestAnimationFrame(tickThumb);
      } else {
        rafId = 0;
        lastTime = 0;
        renderThumb(thumbX);
      }
    }

    function followFinger(clientX) {
      const navLeft = nav.getBoundingClientRect().left;
      const min = getItemCenterX(0);
      const max = getItemCenterX(items.length - 1);

      thumbTargetX = Math.min(Math.max(clientX - navLeft, min), max);

      if (!rafId) {
        lastTime = 0;
        rafId = requestAnimationFrame(tickThumb);
      }
    }

    function stopFollowing() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
        lastTime = 0;
      }

      thumb.classList.remove('is-dragging');
    }

    function getActiveIndex() {
      return items.findIndex(function (item) {
        return item.classList.contains('active-nav-item');
      });
    }

    function syncThumb() {
      moveThumbTo(getActiveIndex(), false);
    }

    /* ---------- Gesture state ---------- */

    let isPointerDown = false;
    let isDragging = false;
    let isLocked = false;

    let activePointerId = null;

    let startX = 0;
    let startY = 0;

    let selectedIndex = -1;
    let originalIndex = -1;
    let bounds = [];

    let suppressNextClick = false;
    let isSyntheticClick = false;
    let suppressTimer = null;

    function measureBounds() {
      const centers = items.map(function (item) {
        const rect = item.getBoundingClientRect();
        return rect.left + rect.width / 2;
      });

      bounds = [];

      for (let i = 0; i < centers.length - 1; i++) {
        bounds.push(centers[i] + (centers[i + 1] - centers[i]) / 2);
      }
    }

    function getNextIndex(clientX, currentIndex) {
      let index = currentIndex;

      while (index < items.length - 1 && clientX > bounds[index]) {
        index++;
      }

      while (index > 0 && clientX < bounds[index - 1]) {
        index--;
      }

      return index;
    }

    function getIndexFromPosition(clientX) {
      let index = 0;

      while (index < bounds.length && clientX > bounds[index]) {
        index++;
      }

      return index;
    }

    /* Uses the SAME class as a normal tap — no new visual state is introduced. */
    function setActiveItem(index, followThumb) {
      items.forEach(function (item, itemIndex) {
        item.classList.toggle('active-nav-item', itemIndex === index);
      });

      if (followThumb !== false) {
        moveThumbTo(index);
      }
    }

    function restoreActiveItem() {
      setActiveItem(originalIndex);
    }

    function releaseCapture(pointerId) {
      try {
        if (nav.hasPointerCapture(pointerId)) {
          nav.releasePointerCapture(pointerId);
        }
      } catch (error) {}
    }

    function resetGesture() {
      isPointerDown = false;
      isDragging = false;
      isLocked = false;

      activePointerId = null;

      startX = 0;
      startY = 0;

      selectedIndex = -1;
      originalIndex = -1;
      bounds = [];

      thumb.classList.remove('is-pressed');
    }

    /* Calls .click() on the EXISTING <a href> — no link is replaced or rewritten. */
    function activateItem(index) {
      const item = items[index];

      if (!item) {
        return;
      }

      const link = item.querySelector('a');

      if (!link) {
        return;
      }

      setActiveItem(index);

      isSyntheticClick = true;

      try {
        link.click();
      } finally {
        isSyntheticClick = false;
      }
    }

    nav.addEventListener('pointerdown', function (event) {
      if (isPointerDown || !event.isPrimary) {
        return;
      }

      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      measureBounds();

      originalIndex = getActiveIndex();

      activePointerId = event.pointerId;
      isPointerDown = true;
      isDragging = false;
      isLocked = false;

      startX = event.clientX;
      startY = event.clientY;

      const pressedItem = event.target.closest('.mobile-bottom-nav--item');
      const pressedIndex = pressedItem ? items.indexOf(pressedItem) : -1;

      if (pressedIndex !== -1) {
        selectedIndex = pressedIndex;
        setActiveItem(pressedIndex);
        thumb.classList.add('is-pressed');
      } else {
        selectedIndex = getIndexFromPosition(event.clientX);
      }
    });

    nav.addEventListener('pointermove', function (event) {
      if (
        !isPointerDown ||
        isLocked ||
        event.pointerId !== activePointerId
      ) {
        return;
      }

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!isDragging) {
        if (
          Math.abs(deltaX) < dragThreshold &&
          Math.abs(deltaY) < dragThreshold
        ) {
          return;
        }

        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          isLocked = true;
          thumb.classList.remove('is-pressed');
          restoreActiveItem();
          return;
        }

        isDragging = true;

        thumb.classList.add('is-dragging', 'is-pressed');

        if (selectedIndex >= 0 && getActiveIndex() !== selectedIndex) {
          setActiveItem(selectedIndex);
        }

        try {
          nav.setPointerCapture(event.pointerId);
        } catch (error) {}
      }

      followFinger(event.clientX);

      const newIndex = getNextIndex(event.clientX, selectedIndex);

      if (
        newIndex !== selectedIndex ||
        !items[newIndex].classList.contains('active-nav-item')
      ) {
        selectedIndex = newIndex;
        setActiveItem(newIndex, false);
      }
    });

    nav.addEventListener('pointerup', function (event) {
      if (!isPointerDown || event.pointerId !== activePointerId) {
        return;
      }

      const wasDragging = isDragging;
      const indexToOpen = selectedIndex;

      releaseCapture(event.pointerId);

      if (wasDragging) {
        stopFollowing();
        moveThumbTo(indexToOpen);

        suppressNextClick = true;
        clearTimeout(suppressTimer);
        suppressTimer = setTimeout(function () {
          suppressNextClick = false;
        }, 400);
      }

      resetGesture();

      if (wasDragging) {
        activateItem(indexToOpen);
      }
      /* Plain tap: nothing above ran, native click fires exactly as before. */
    });

    nav.addEventListener('pointercancel', function (event) {
      if (!isPointerDown || event.pointerId !== activePointerId) {
        return;
      }

      releaseCapture(event.pointerId);
      stopFollowing();
      resetGesture();
      restoreActiveItem();
    });

    nav.addEventListener(
      'click',
      function (event) {
        if (isSyntheticClick || !suppressNextClick) {
          return;
        }

        suppressNextClick = false;
        clearTimeout(suppressTimer);

        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    nav.addEventListener('click', function (event) {
      const item = event.target.closest('.mobile-bottom-nav--item');

      if (!item) {
        return;
      }

      const index = items.indexOf(item);

      if (index !== -1) {
        setActiveItem(index);
      }
    });

    syncThumb();

    /* ADDED: the very first measurement can happen before the icon
       (font-based or otherwise) has fully settled into its final size,
       which is why only the first paint was ever slightly off — any
       later re-measure (tap, resize) was already using final sizes.
       These two just re-run the same syncThumb() once things settle,
       nothing else changes. */
    requestAnimationFrame(function () {
      requestAnimationFrame(syncThumb);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncThumb);
    }

    window.addEventListener('load', syncThumb);
    window.addEventListener('resize', syncThumb);
    window.addEventListener('orientationchange', syncThumb);

    nav.addEventListener('contextmenu', function (event) {
      event.preventDefault();
    });

    nav.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function initAllBottomNavs() {
    const navs = document.querySelectorAll('[data-bottom-nav]');

    navs.forEach(function (nav) {
      initMobileBottomNav(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBottomNavs);
  } else {
    initAllBottomNavs();
  }

  document.addEventListener('shopify:section:load', initAllBottomNavs);
  document.addEventListener('shopify:section:reorder', initAllBottomNavs);
})();